import cn from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { H2, H4, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_NAME, YANDEX_1, YANDEX_3, YANDEX_8, YANDEX_STATUS, YANDEX_SUBSTATUS_ALL } from '../../../../constans';
import { numberWithSpaces } from '../../../../utils';
import { calcYandexProfit } from '../../../../utils/yandex';
import { getPostingItemPrice } from '../index';
import styles from './styles.module.scss';
import { Column } from '../../../../components/Basic/Blocks';
import CommissionNdsBlock from '../../../../components/Markets/Blocks/CommissionNdsBlock';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import { Input } from '../../../../components/Basic/Inputs';

const width = ['120px', '400px', '170px', '100px', '200px', '180px', '120px', '80px'];

const MARKET_ID = {
  [YANDEX_1]: '21623713',
  [YANDEX_3]: '22071066',
  'YANDEX-4': '22887912',
  'YANDEX-5': '22908529',
  'YANDEX-6': '53120673',
  'YANDEX-7': '53122012',
  [YANDEX_8]: '53116941',
};

const ORDER_LINK = (shop) => `https://partner.market.yandex.ru/supplier/${MARKET_ID[shop]}/orders/`;
const DOWNLOAD_LINK = (shop) =>
  `https://partner.market.yandex.ru/api/supplier/${MARKET_ID[shop]}/order/parcelBoxLabel/`;

export const formOrderLink = (id, shop) => `${ORDER_LINK(shop)}${id}`;
export const formStickerLink = (id, shop) => `${DOWNLOAD_LINK(shop)}${id}/${id}-1.pdf`;

const YandexTableOrders = ({ shop = '', orders = [], map = {}, pager = {}, total = 0, onChange = (_) => _ }) => {
  const user = useSelector((store) => store.user);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  return (
    <>
      <H2 style={{ marginBottom: '10px' }}>Всего заказов: {total}</H2>

      <Table styles={styles.table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[3]} centerText>Площадка</HeaderTitle>
          <HeaderTitle width={width[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={width[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={width[2]}>Статус заказа</HeaderTitle>
          <HeaderTitle width={width[3]} centerText>Цена продажи</HeaderTitle>
          <HeaderTitle width={width[3]} centerText>Сумма, ₽</HeaderTitle>
          {isOwner && (
            <>
              <HeaderTitle width={width[3]} centerText>
                Цена закупки
              </HeaderTitle>
            </>
          )}
          <HeaderTitle width={width[4]}>Прибыль/комиссия</HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Артикул на складе
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Квант продаж
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Остаток
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Остаток на складе
          </HeaderTitle>
        </TableHeader>
        {orders.map((order, key) => {
          const mapByShop = map[order.shop]

          return (

            <TableLine key={order.id}>
              <TableCell width={width[3]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.shop}
                </Column>
              </TableCell>
              <TableCell width={width[0]} minWidth={width[0]}>
                <a href={formOrderLink(order.id, shop)} target="_blank" className={styles.link} rel="noopener noreferrer">
                  {order.id}
                </a>
                <TextGrey fontSize={14}>{order.creationDate}</TextGrey>
              </TableCell>
              <TableCell width={width[1]}>
                <Column>
                  {order.items.map((p, k) => {
                    const item = mapByShop[p.offerId] || {};
                    let loaded = !!mapByShop[p.offerId];
                    const img = loaded ? item.images || [] : []; // eslint-disable-next-line react/no-array-index-key
                    return (
                      <div key={k} className={styles.div_line_images}>
                        <div className={styles.wrapper}>
                          <img
                            onClick={() => openImageViewer(img)}
                            className={styles.preview}
                            src={img.length > 0 ? img[0] : undefined}
                          />
                        </div>
                        <div className={styles.name}>
                          {`${p.count} x ${p.offerName}`} <TextGrey fontSize={12}>{p.offerId}</TextGrey>
                          {(mapByShop[p.offerId] || { stocks_warehouse: 0 }).stocks_warehouse > 0 && (
                            <div
                              className={cn(
                                styles.warehouse_block,
                                (mapByShop[p.offerId] || { stocks_warehouse: 0 }).stocks_warehouse ===
                                (mapByShop[p.offerId] || {}).stocks && styles.only_warehouse,
                              )}
                            >
                              Склад
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Column>
              </TableCell>
              <TableCell width={width[2]}>
                <H4>{YANDEX_STATUS[order.status]}</H4>
                <TextGrey fontSize={14}> {YANDEX_SUBSTATUS_ALL[order.substatus]}</TextGrey>
              </TableCell>
              { }
              <TableCell width={width[3]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      {numberWithSpaces(Math.ceil(getPostingItemPrice(p)))}
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[3]} center>
                <H4>
                  {Math.ceil(order.buyerItemsTotal + (order.subsidies || []).reduce((acc, item) => acc + item.amount, 0))}
                </H4>
              </TableCell>
              {isOwner && (
                <TableCell width={width[3]}>
                  <Column>
                    {order.items.map((p, k) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={k} className={styles.div_line}>
                        <Input
                          value={(mapByShop[p.offerId] || {}).purchase}
                          onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'purchase', v)}
                          center
                        />
                      </div>
                    ))}
                  </Column>
                </TableCell>
              )}

              <TableCell width={width[4]}>
                {isOwner ? (
                  <Column>
                    {order.items.map((p, k) => {
                      const data = { ...mapByShop[p.offerId], price: getPostingItemPrice(p) };
                      const profit = p.profit;
                      const allProfit = Math.ceil((profit?.rub * p.count) / data.min_quantity);
                      return (
                        <div key={k} className={styles.div_commission}>
                          <>
                            <Text className={styles.block_mar}>{profit?.percent} %</Text>
                            <div className={styles.block_commission}>
                              <Text className={profit?.is_minus ? styles.red_text : styles.green_text}>
                                {numberWithSpaces(profit?.rub)}
                              </Text>
                              <CommissionNdsBlock
                                card={{ ...mapByShop[p.offerId], profit: p.profit, commission: p.commission }}
                                market={'YANDEX'}
                              />
                            </div>
                            <Text fontWeight={600} className={styles.all_profit}>
                              {allProfit}
                            </Text>
                          </>
                        </div>
                      );
                    })}
                  </Column>
                ) : (
                  <Column>
                    {order.items.map((p, k) => {
                      const data = { ...mapByShop[p.offerId], price: getPostingItemPrice(p) };
                      const profit = data.loaded ? calcYandexProfit(data) : 0;
                      return (
                        <>
                          {data.loaded && (
                            <Text
                              className={profit < 0 ? styles.red_text : styles.green_text}
                              style={{ textAlign: 'center' }}
                            >
                              {profit < 0 ? `В минус на ${profit}` : 'ок'}
                            </Text>
                          )}
                        </>
                      );
                    })}
                  </Column>
                )}
              </TableCell>
              <TableCell width={width[5]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <ProviderList
                        selectProviderId={(mapByShop[p.offerId] || {}).provider_id}
                        disabled={!isOwner}
                        onSelect={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'provider_id', v.id)}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).provider_artnumber}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'provider_artnumber', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).warehouse_id}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'warehouse_id', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).quantity}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).min_quantity}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'min_quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).stock?.[MAP_SKLAD_NAME[shop]]?.common}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'stock', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input value={(mapByShop[p.offerId] || {}).stock?.[MAP_SKLAD_NAME[shop]]?.warehouse} readOnly center />
                    </div>
                  ))}
                </Column>
              </TableCell>
            </TableLine>
          )
        }
        )}
      </Table>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default YandexTableOrders;
